export default __webpack_public_path__ + "6238a95f863e6d4d5c3a0ddecb049fcb.png";